import { render, staticRenderFns } from "./NuevaVenta.vue?vue&type=template&id=65ff0c83"
import script from "./NuevaVenta.vue?vue&type=script&lang=js"
export * from "./NuevaVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports